/* Bloomie theme JavaScript */
(() => {
  const B = window.Bloomie || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reduceMotion = () =>
    document.body.classList.contains('motion-off') ||
    document.body.classList.contains('motion-always') ||
    (document.body.classList.contains('motion-respect') && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- Money ---------- */
  function formatMoney(cents, format = B.moneyFormat || '${{amount}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const n = Number(cents) / 100;
    const fmt = (num, dec = 2, thou = ',', decSep = '.') => {
      const parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return dec ? parts.join(decSep) : parts[0];
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(n, 0);
        case 'amount_with_comma_separator': return fmt(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(n, 0, '.');
        case 'amount_with_apostrophe_separator': return fmt(n, 2, "'");
        default: return fmt(n, 2);
      }
    });
  }
  B.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('#Toast');
    if (!el) return;
    el.innerHTML = '<span class="icon-btn icon-btn--accent icon-btn--outline" aria-hidden="true" style="width:34px;height:34px"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M5 12l5 5 9-10"/></svg></span>';
    const span = document.createElement('span');
    span.textContent = msg;
    el.appendChild(span);
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => (el.hidden = true), 3200);
  }
  B.toast = toast;

  /* ---------- Overlay / drawers / modals ---------- */
  let lastFocus = null;
  const overlay = document.createElement('div');
  overlay.className = 'overlay';
  document.addEventListener('DOMContentLoaded', () => document.body.appendChild(overlay));

  function openPanel(panel) {
    if (!panel) return;
    lastFocus = document.activeElement;
    closeAll();
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (!panel.classList.contains('modal')) overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    const focusable = panel.querySelector('input:not([type=hidden]), button, a[href], [tabindex="0"]');
    setTimeout(() => focusable && focusable.focus(), 50);
  }
  function closeAll() {
    $$('.drawer.is-open, .modal.is-open, .search-pop.is-open').forEach((p) => {
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
    });
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }
  function closePanel() {
    closeAll();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  B.openPanel = openPanel;
  B.closePanel = closePanel;
  overlay.addEventListener('click', closePanel);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closePanel();
      closeMenus();
    }
  });
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const target = document.getElementById(opener.dataset.open);
      if (target) {
        e.preventDefault();
        openPanel(target);
        if (target.id === 'CartDrawer') refreshCartRecs();
      }
    }
    if (e.target.closest('[data-close]')) {
      e.preventDefault();
      closePanel();
    }
  });

  /* ---------- Announcement bar ---------- */
  function initAnnouncement(root = document) {
    $$('[data-announcement]', root).forEach((bar) => {
      const slides = $$('.announcement__slide', bar);
      if (slides.length < 2) return;
      let i = 0;
      const go = (n) => {
        slides[i].classList.remove('is-active');
        slides[i].setAttribute('aria-hidden', 'true');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        slides[i].setAttribute('aria-hidden', 'false');
      };
      const speed = Number(bar.dataset.speed || 5) * 1000;
      let timer = setInterval(() => go(i + 1), speed);
      const reset = () => { clearInterval(timer); timer = setInterval(() => go(i + 1), speed); };
      const prev = $('[data-prev]', bar), next = $('[data-next]', bar);
      prev && prev.addEventListener('click', () => { go(i - 1); reset(); });
      next && next.addEventListener('click', () => { go(i + 1); reset(); });
      bar.addEventListener('mouseenter', () => clearInterval(timer));
      bar.addEventListener('mouseleave', reset);
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdowns(root = document) {
    $$('[data-countdown]', root).forEach((el) => {
      const end = new Date(el.dataset.countdown).getTime();
      if (isNaN(end)) return;
      const units = {
        d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el),
      };
      const text = $('[data-countdown-text]', el);
      const tick = () => {
        let diff = Math.max(0, end - Date.now());
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        const pad = (n) => String(n).padStart(2, '0');
        if (text) text.textContent = `${pad(d)}D : ${pad(h)}H : ${pad(m)}M : ${pad(s)}S`;
        if (units.d) units.d.textContent = pad(d);
        if (units.h) units.h.textContent = pad(h);
        if (units.m) units.m.textContent = pad(m);
        if (units.s) units.s.textContent = pad(s);
        if (end - Date.now() <= 0) {
          clearInterval(t);
          if (el.dataset.hideWhenDone === 'true') el.hidden = true;
        }
      };
      tick();
      const t = setInterval(tick, 1000);
    });
  }

  /* ---------- Header ---------- */
  function closeMenus(except) {
    $$('.mega.is-open, .dropdown.is-open').forEach((m) => {
      if (m === except) return;
      m.classList.remove('is-open');
      const btn = document.querySelector(`[aria-controls="${m.id}"]`);
      btn && btn.setAttribute('aria-expanded', 'false');
    });
  }
  function initHeader(root = document) {
    const wrap = $('[data-header]', root);
    if (!wrap) return;
    $$('[data-menu-toggle]', wrap).forEach((btn) => {
      const menu = document.getElementById(btn.getAttribute('aria-controls'));
      if (!menu) return;
      const item = btn.closest('.nav-item') || btn;
      let hoverTimer;
      const open = () => { clearTimeout(hoverTimer); closeMenus(menu); menu.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
      const close = () => { hoverTimer = setTimeout(() => { menu.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }, 150); };
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        menu.classList.contains('is-open') ? (menu.classList.remove('is-open'), btn.setAttribute('aria-expanded', 'false')) : open();
      });
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      menu.addEventListener('mouseenter', () => clearTimeout(hoverTimer));
      menu.addEventListener('mouseleave', close);
    });
    document.addEventListener('click', (e) => { if (!e.target.closest('[data-header]')) closeMenus(); });

    const sticky = wrap.dataset.sticky;
    const transparent = wrap.classList.contains('header-wrap--transparent');
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      if (transparent) wrap.classList.toggle('is-scrolled', y > 40);
      if (sticky === 'scroll-up') wrap.classList.toggle('is-hidden', y > lastY && y > 200);
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Predictive search ---------- */
  function initSearch() {
    const pop = $('#SearchPopup');
    if (!pop) return;
    const input = $('input[type="search"]', pop);
    const results = $('[data-search-results]', pop);
    const suggestions = $('[data-search-suggestions]', pop);
    let ctrl;
    let timer;
    input && input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        ctrl && ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = `${B.routes.search}/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,query&resources[limit]=4`;
          const res = await fetch(url, { signal: ctrl.signal });
          const data = await res.json();
          const products = (data.resources.results.products || []);
          const queries = (data.resources.results.queries || []);
          results.innerHTML = products.length
            ? products.map((p) => `<a class="search-pop__result" href="${p.url}"><div class="media">${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : ''}</div><b style="font-family:var(--f-heading)">${escapeHtml(p.title)}</b><span>${formatMoney(Math.round(parseFloat(p.price) * 100))}</span></a>`).join('')
            : `<p>No products found for “${escapeHtml(q)}”.</p>`;
          if (suggestions && queries.length) {
            suggestions.innerHTML = queries.map((s) => `<a class="chip" href="${s.url}">${escapeHtml(s.text)}</a>`).join('');
          }
        } catch (e) { /* aborted */ }
      }, 220);
    });
  }
  function escapeHtml(s) { const d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  /* ---------- Cart ---------- */
  async function cartFetch(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Something went wrong');
    return data;
  }
  function renderCartSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = html.querySelector('#CartDrawerInner');
      const current = $('#CartDrawerInner');
      if (fresh && current) current.replaceWith(fresh);
      initCartDrawer();
    }
  }
  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
  }
  async function refreshCount() {
    const cart = await (await fetch(`${B.routes.cart}.js`)).json();
    updateCount(cart.item_count);
    return cart;
  }
  async function addToCart(items, button) {
    if (button) { button.setAttribute('aria-disabled', 'true'); button.dataset.label = button.innerHTML; button.textContent = 'Adding…'; }
    try {
      const data = await cartFetch(`${B.routes.cartAdd}.js`, { items, sections: 'cart-drawer', sections_url: window.location.pathname });
      renderCartSections(data.sections);
      await refreshCount();
      if (B.cartType === 'drawer' && $('#CartDrawer')) {
        closeAll();
        openPanel($('#CartDrawer'));
        refreshCartRecs(items[0] && items[0].id);
      } else {
        toast('Added to your bag');
      }
    } catch (err) {
      toast(err.message);
    } finally {
      if (button) { button.removeAttribute('aria-disabled'); button.innerHTML = button.dataset.label; }
    }
  }
  B.addToCart = addToCart;

  async function changeLine(key, quantity) {
    const drawer = $('#CartDrawer');
    drawer && drawer.classList.add('is-loading');
    try {
      const data = await cartFetch(`${B.routes.cartChange}.js`, { id: key, quantity, sections: 'cart-drawer', sections_url: window.location.pathname });
      renderCartSections(data.sections);
      updateCount(data.item_count);
      if (document.body.classList.contains('template-cart')) window.location.reload();
    } catch (err) { toast(err.message); }
    drawer && drawer.classList.remove('is-loading');
  }

  let noteTimer;
  function initCartDrawer() {
    const root = $('#CartDrawerInner');
    if (!root) return;
    $$('[data-line-qty]', root).forEach((wrap) => {
      const key = wrap.dataset.lineQty;
      const input = $('input', wrap);
      $('[data-qty-minus]', wrap).addEventListener('click', () => changeLine(key, Math.max(0, Number(input.value) - 1)));
      $('[data-qty-plus]', wrap).addEventListener('click', () => changeLine(key, Number(input.value) + 1));
      input.addEventListener('change', () => changeLine(key, Math.max(0, Number(input.value))));
    });
    $$('[data-line-remove]', root).forEach((b) => b.addEventListener('click', () => changeLine(b.dataset.lineRemove, 0)));

    const wrap = $('[data-gift-wrap]', root);
    wrap && wrap.addEventListener('change', async () => {
      const variant = wrap.dataset.variant;
      if (wrap.checked) {
        await addToCartSilently(variant);
      } else {
        await changeLine(wrap.dataset.lineKey, 0);
      }
    });
    const note = $('[data-gift-message]', root);
    note && note.addEventListener('input', () => {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(() => cartFetch(`${B.routes.cartUpdate}.js`, { attributes: { 'Gift message': note.value } }).catch(() => {}), 500);
    });
    const discountForm = $('[data-discount-form]', root);
    if (discountForm) {
      const input = $('input', discountForm);
      const checkout = $('[data-checkout]', root);
      const saved = sessionStorage.getItem('bloomie:discount');
      if (saved) { input.value = saved; applyDiscountLink(checkout, saved); }
      discountForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const code = input.value.trim();
        sessionStorage.setItem('bloomie:discount', code);
        applyDiscountLink(checkout, code);
        const msg = $('[data-discount-msg]', root);
        if (msg) msg.textContent = code ? `Code “${code}” will be applied at checkout.` : '';
      });
    }
  }
  function applyDiscountLink(checkout, code) {
    if (!checkout) return;
    checkout.setAttribute('href', code ? `/checkout?discount=${encodeURIComponent(code)}` : '/checkout');
  }
  async function addToCartSilently(variantId) {
    try {
      const data = await cartFetch(`${B.routes.cartAdd}.js`, { items: [{ id: Number(variantId), quantity: 1 }], sections: 'cart-drawer', sections_url: window.location.pathname });
      renderCartSections(data.sections);
      await refreshCount();
      if (document.body.classList.contains('template-cart')) window.location.reload();
    } catch (err) { toast(err.message); }
  }

  async function refreshCartRecs(variantId) {
    const box = $('[data-cart-recs]');
    if (!box) return;
    let productId = box.dataset.productId;
    if (!productId) {
      const cart = await (await fetch(`${B.routes.cart}.js`)).json();
      if (!cart.items.length) { box.closest('[data-cart-recs-wrap]').hidden = true; return; }
      productId = cart.items[0].product_id;
    }
    try {
      const res = await fetch(`${B.routes.recommendations}.json?product_id=${productId}&limit=4`);
      const data = await res.json();
      const items = (data.products || []).filter((p) => p.available).slice(0, 2);
      if (!items.length) { box.closest('[data-cart-recs-wrap]').hidden = true; return; }
      box.closest('[data-cart-recs-wrap]').hidden = false;
      box.innerHTML = items.map((p) => {
        const v = p.variants.find((x) => x.available) || p.variants[0];
        const img = p.featured_image ? `<img src="${p.featured_image}" alt="" loading="lazy" width="48" height="60">` : '';
        const action = p.variants.length > 1
          ? `<button type="button" class="icon-btn icon-btn--outline icon-btn--accent" data-quick-view="${p.url}" aria-label="Choose options for ${escapeHtml(p.title)}">+</button>`
          : `<button type="button" class="icon-btn icon-btn--outline icon-btn--accent" data-quick-add="${v.id}" aria-label="Add ${escapeHtml(p.title)}">+</button>`;
        return `<div class="cart-rec">${img}<div class="cart-rec__info"><a href="${p.url}"><b>${escapeHtml(p.title)}</b></a><span>${formatMoney(p.price)}</span></div>${action}</div>`;
      }).join('');
    } catch (e) { box.closest('[data-cart-recs-wrap]').hidden = true; }
  }

  /* ---------- Product forms ---------- */
  function initProductForms(root = document) {
    $$('[data-product-form]', root).forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      const json = $('[data-product-json]', form.closest('[data-product-root]') || form);
      const product = json ? JSON.parse(json.textContent) : null;
      const idInput = $('input[name="id"]', form);
      const submit = $('[data-add-button]', form);
      const rootEl = form.closest('[data-product-root]') || form;
      const priceEl = $('[data-price]', rootEl);
      const update = () => {
        if (!product) return;
        const selected = $$('[data-option-index]', form).map((g) => {
          const checked = $('input:checked', g) || $('select', g);
          return checked ? checked.value : null;
        });
        const variant = product.variants.find((v) => v.options.every((o, i) => o === selected[i]));
        // mark unavailable values for the last option
        $$('[data-option-index]', form).forEach((g, idx) => {
          $$('input', g).forEach((inp) => {
            const test = selected.slice(); test[idx] = inp.value;
            const match = product.variants.find((v) => v.options.every((o, i) => o === test[i]));
            inp.classList.toggle('is-unavailable', !match || !match.available);
          });
          const legendVal = $('[data-selected-value]', g);
          if (legendVal) legendVal.textContent = selected[idx] || '';
        });
        if (!variant) {
          submit && (submit.disabled = true, submit.textContent = 'Unavailable');
          return;
        }
        idInput.value = variant.id;
        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available ? (submit.dataset.addLabel || 'Add to bag') : 'Sold out';
        }
        if (priceEl) {
          priceEl.innerHTML = variant.compare_at_price > variant.price
            ? `<s class="price__was">${formatMoney(variant.compare_at_price)}</s><span class="price__now">${formatMoney(variant.price)}</span>`
            : `<span class="price__now">${formatMoney(variant.price)}</span>`;
        }
        if (variant.featured_media && rootEl.dataset.swapImage !== 'false') {
          const img = $(`[data-media-id="${variant.featured_media.id}"]`, rootEl);
          if (img) img.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        }
        if (form.dataset.updateUrl === 'true' && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
        rootEl.dispatchEvent(new CustomEvent('variant:change', { detail: variant, bubbles: true }));
      };
      form.addEventListener('change', update);
      update();
      form.addEventListener('submit', (e) => {
        if (form.dataset.ajax === 'false') return;
        e.preventDefault();
        const qtyInput = $('input[name="quantity"]', form);
        const item = { id: Number(idInput.value), quantity: Number(qtyInput ? qtyInput.value : 1) };
        const props = {};
        $$('[name^="properties["]', form).forEach((el) => {
          if (el.disabled || (el.type === 'checkbox' && !el.checked) || el.value === '') return;
          props[el.name.slice(11, -1)] = el.value;
        });
        if (Object.keys(props).length) item.properties = props;
        const items = [item];
        const wrap = $('[data-pdp-gift-wrap]', form);
        if (wrap && wrap.checked) items.push({ id: Number(wrap.value), quantity: 1 });
        addToCart(items, submit);
      });
    });
    $$('[data-qty]', root).forEach((q) => {
      if (q.dataset.ready) return;
      q.dataset.ready = '1';
      const input = $('input', q);
      $('[data-qty-minus]', q).addEventListener('click', () => { input.value = Math.max(1, Number(input.value) - 1); });
      $('[data-qty-plus]', q).addEventListener('click', () => { input.value = Number(input.value) + 1; });
    });
  }
  B.initProductForms = initProductForms;

  /* ---------- Quick add + quick view ---------- */
  document.addEventListener('click', async (e) => {
    const qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      addToCart([{ id: Number(qa.dataset.quickAdd), quantity: 1 }], qa);
      return;
    }
    const qv = e.target.closest('[data-quick-view]');
    if (qv) {
      e.preventDefault();
      const modal = $('#QuickView');
      if (!modal) { window.location.href = qv.dataset.quickView; return; }
      const body = $('[data-quick-view-body]', modal);
      body.innerHTML = '<p style="padding:40px;text-align:center">Loading…</p>';
      openPanel(modal);
      try {
        const url = qv.dataset.quickView.split('?')[0] + '?view=quick-view';
        const html = await (await fetch(url)).text();
        body.innerHTML = html;
        initProductForms(body);
        initWishlist(body);
        const first = $('input, button, a[href]', body);
        first && first.focus();
      } catch (err) {
        window.location.href = qv.dataset.quickView;
      }
    }
  });

  document.addEventListener('click', (e) => {
    const look = e.target.closest('[data-add-look]');
    if (!look) return;
    e.preventDefault();
    const ids = look.dataset.addLook.split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
    if (ids.length) addToCart(ids, look);
  });

  /* ---------- Wishlist ---------- */
  const WKEY = 'bloomie:wishlist';
  const getWish = () => { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } };
  const setWish = (list) => { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {} };
  function initWishlist(root = document) {
    if (!B.wishlist) return;
    const list = getWish();
    $$('[data-wishlist-toggle]', root).forEach((btn) => {
      btn.setAttribute('aria-pressed', list.includes(btn.dataset.wishlistToggle) ? 'true' : 'false');
    });
    $$('[data-wishlist-count]').forEach((el) => { el.textContent = list.length; el.hidden = !list.length; });
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.wishlistToggle;
    let list = getWish();
    const saved = list.includes(handle);
    list = saved ? list.filter((h) => h !== handle) : [handle, ...list];
    setWish(list);
    initWishlist();
    toast(saved ? 'Removed from your wishlist' : 'Saved to your wishlist');
  });
  B.getWishlist = getWish;

  /* ---------- Recently viewed ---------- */
  const RKEY = 'bloomie:recent';
  function trackRecent() {
    const el = $('[data-recent-track]');
    if (!el) return;
    const h = el.dataset.recentTrack;
    let list = [];
    try { list = JSON.parse(localStorage.getItem(RKEY)) || []; } catch (e) {}
    list = [h, ...list.filter((x) => x !== h)].slice(0, 12);
    try { localStorage.setItem(RKEY, JSON.stringify(list)); } catch (e) {}
  }
  async function renderRecent(root = document) {
    for (const box of $$('[data-recently-viewed]', root)) {
      let list = [];
      try { list = JSON.parse(localStorage.getItem(RKEY)) || []; } catch (e) {}
      const current = box.dataset.exclude;
      list = list.filter((h) => h !== current).slice(0, Number(box.dataset.limit || 5));
      const section = box.closest('[data-recent-section]');
      if (!list.length) { if (section && !window.Shopify?.designMode) section.hidden = true; continue; }
      const cards = await Promise.all(list.map((h) => fetch(`${B.routes.root.replace(/\/$/, '')}/products/${h}?view=card`).then((r) => (r.ok ? r.text() : '')).catch(() => '')));
      box.innerHTML = cards.join('');
      if (section) section.hidden = false;
      initWishlist(box);
    }
  }

  /* ---------- Carousels ---------- */
  function initCarousels(root = document) {
    $$('[data-carousel]', root).forEach((c) => {
      const tracks = $$('[data-carousel-track]', c);
      if (!tracks.length) return;
      const visible = () => tracks.find((t) => t.offsetParent !== null) || tracks[0];
      const track = tracks[0];
      const prev = $('[data-carousel-prev]', c), next = $('[data-carousel-next]', c);
      const move = (dir) => { const t = visible(); t.scrollBy({ left: dir * t.clientWidth * 0.9, behavior: reduceMotion() ? 'auto' : 'smooth' }); };
      prev && prev.addEventListener('click', () => move(-1));
      next && next.addEventListener('click', () => move(1));
      const dots = $$('[data-carousel-dot]', c);
      if (dots.length) {
        const kids = Array.from(track.children);
        dots.forEach((d, i) => d.addEventListener('click', () => kids[i] && track.scrollTo({ left: kids[i].offsetLeft - track.offsetLeft, behavior: reduceMotion() ? 'auto' : 'smooth' })));
        track.addEventListener('scroll', () => {
          const idx = Math.round(track.scrollLeft / (kids[0] ? kids[0].getBoundingClientRect().width + 24 : 1));
          dots.forEach((d, i) => d.setAttribute('aria-current', i === idx ? 'true' : 'false'));
        }, { passive: true });
      }
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs(root = document) {
    $$('[data-tabs]', root).forEach((wrap) => {
      const tabs = $$('[role="tab"]', wrap);
      const panels = $$('[role="tabpanel"]', wrap);
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => {
          tabs.forEach((t, j) => { t.setAttribute('aria-selected', i === j ? 'true' : 'false'); t.tabIndex = i === j ? 0 : -1; });
          panels.forEach((p, j) => (p.hidden = i !== j));
        });
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[n].focus(); tabs[n].click();
        });
      });
    });
  }

  /* ---------- Slideshow ---------- */
  function initSlideshows(root = document) {
    $$('[data-slideshow]', root).forEach((s) => {
      const slides = $$('.slideshow__slide', s);
      const dots = $$('[data-slide-dot]', s);
      if (slides.length < 2) return;
      let i = 0;
      const go = (n) => {
        slides[i].classList.remove('is-active');
        dots[i] && dots[i].setAttribute('aria-current', 'false');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        dots[i] && dots[i].setAttribute('aria-current', 'true');
      };
      dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
      const prev = $('[data-slide-prev]', s), next = $('[data-slide-next]', s);
      prev && prev.addEventListener('click', () => go(i - 1));
      next && next.addEventListener('click', () => go(i + 1));
      const speed = Number(s.dataset.autoplay || 0) * 1000;
      if (speed && !reduceMotion()) {
        let timer = setInterval(() => go(i + 1), speed);
        const pause = $('[data-slide-pause]', s);
        pause && pause.addEventListener('click', () => {
          const playing = pause.getAttribute('aria-pressed') !== 'true';
          pause.setAttribute('aria-pressed', playing ? 'true' : 'false');
          pause.setAttribute('aria-label', playing ? 'Play slideshow' : 'Pause slideshow');
          clearInterval(timer);
          if (!playing) timer = setInterval(() => go(i + 1), speed);
        });
      }
    });
  }

  /* ---------- Hotspots ---------- */
  document.addEventListener('click', (e) => {
    const dot = e.target.closest('.hotspot__dot');
    $$('.hotspot.is-open').forEach((h) => {
      if (!dot || h !== dot.closest('.hotspot')) { h.classList.remove('is-open'); $('.hotspot__dot', h).setAttribute('aria-expanded', 'false'); }
    });
    if (dot) {
      const h = dot.closest('.hotspot');
      const open = !h.classList.contains('is-open');
      h.classList.toggle('is-open', open);
      dot.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });

  /* ---------- Vertical accordion ---------- */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('.vacc__tab');
    if (!tab) return;
    const wrap = tab.closest('.vacc');
    $$('.vacc__panel', wrap).forEach((p) => {
      const open = p === tab.closest('.vacc__panel');
      p.classList.toggle('is-open', open);
      const t = $('.vacc__tab', p);
      t && t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Video cards ---------- */
  document.addEventListener('click', (e) => {
    const card = e.target.closest('[data-video-card]');
    if (!card || e.target.closest('a')) return;
    const video = $('video', card);
    if (!video) return;
    e.preventDefault();
    if (video.paused) { $$('[data-video-card] video').forEach((v) => v !== video && v.pause()); video.muted = false; video.controls = true; video.play(); card.classList.add('is-playing'); }
    else { video.pause(); card.classList.remove('is-playing'); }
  });
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-video-toggle]');
    if (!btn) return;
    const video = document.getElementById(btn.dataset.videoToggle);
    if (!video) return;
    if (video.paused) { video.play(); btn.setAttribute('aria-label', 'Pause video'); btn.setAttribute('aria-pressed', 'false'); }
    else { video.pause(); btn.setAttribute('aria-label', 'Play video'); btn.setAttribute('aria-pressed', 'true'); }
  });

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root = document) {
    const els = $$('.js-reveal:not(.is-visible)', root);
    if (!('IntersectionObserver' in window) || reduceMotion()) { els.forEach((el) => el.classList.add('is-visible')); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } }), { threshold: 0.12 });
    els.forEach((el) => io.observe(el));
  }

  /* ---------- Init ---------- */
  function initAll(root = document) {
    initAnnouncement(root);
    initCountdowns(root);
    initCarousels(root);
    initTabs(root);
    initSlideshows(root);
    initProductForms(root);
    initWishlist(root);
    initReveal(root);
    renderRecent(root);
  }
  B.refresh = initAll;
  B.refreshCartRecs = refreshCartRecs;
  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initSearch();
    initCartDrawer();
    trackRecent();
    initAll();
  });
  document.addEventListener('shopify:section:load', (e) => {
    initAll(e.target);
    if (e.target.querySelector('[data-header]')) initHeader(e.target);
  });
})();

/* ==========================================================
   Round 2: product page, collection filters, cart page
   ========================================================== */
(() => {
  const B = window.Bloomie;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const fmt = (c) => B.formatMoney(c);

  /* ---------- Product gallery ---------- */
  function initGallery(root = document) {
    $$('[data-gallery]', root).forEach((g) => {
      if (g.dataset.ready) return;
      g.dataset.ready = '1';
      const main = $('[data-gallery-main]', g);
      const thumbs = $$('[data-thumb]', g);
      const slides = $$('.pdp__slide', main);
      const setActive = (i) => thumbs.forEach((t, j) => t.classList.toggle('is-active', i === j));
      thumbs.forEach((t) => t.addEventListener('click', () => {
        const i = Number(t.dataset.thumb);
        const slide = slides[i];
        if (!slide) return;
        main.scrollTo({ left: slide.offsetLeft - main.offsetLeft, behavior: 'smooth' });
        setActive(i);
      }));
      main.addEventListener('scroll', () => {
        if (!slides.length) return;
        const i = Math.round(main.scrollLeft / slides[0].getBoundingClientRect().width);
        setActive(i);
      }, { passive: true });
      // variant image jump
      const rootEl = g.closest('[data-product-root]');
      rootEl && rootEl.addEventListener('variant:change', (e) => {
        const v = e.detail;
        if (!v.featured_media) return;
        const slide = $(`[data-media-id="${v.featured_media.id}"]`, g);
        if (!slide) return;
        if (main.scrollWidth > main.clientWidth) {
          main.scrollTo({ left: slide.offsetLeft - main.offsetLeft, behavior: 'smooth' });
          setActive(Number(slide.dataset.index));
        } else {
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  }

  /* ---------- Lightbox zoom ---------- */
  let lastZoomFocus = null;
  document.addEventListener('click', (e) => {
    const z = e.target.closest('[data-zoom]');
    if (z) {
      const g = z.closest('[data-gallery]');
      if (g && g.dataset.zoomEnabled === 'false') return;
      const box = $('[data-lightbox]', z.closest('section') || document);
      if (!box) return;
      lastZoomFocus = z;
      const img = $('[data-lightbox-img]', box);
      img.src = z.dataset.zoom;
      img.alt = ($('img', z) || {}).alt || '';
      box.classList.remove('is-zoomed');
      box.classList.add('is-open');
      box.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      $('[data-lightbox-close]', box).focus();
      return;
    }
    const box = e.target.closest('[data-lightbox]');
    if (box) {
      if (e.target.closest('[data-lightbox-close]')) return closeLightbox(box);
      if (e.target.matches('[data-lightbox-img]')) { box.classList.toggle('is-zoomed'); return; }
      closeLightbox(box);
    }
  });
  function closeLightbox(box) {
    box.classList.remove('is-open', 'is-zoomed');
    box.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    lastZoomFocus && lastZoomFocus.focus();
  }
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('[data-lightbox].is-open').forEach(closeLightbox); });

  /* ---------- Stock indicator + sale badge ---------- */
  function initStock(root = document) {
    $$('[data-product-root]', root).forEach((r) => {
      const stock = $('[data-stock]', r);
      const invEl = $('[data-inventory]', r);
      const inv = invEl ? JSON.parse(invEl.textContent) : {};
      const render = (v) => {
        if (stock) {
          const q = inv[v.id];
          const th = Number(stock.dataset.threshold || 5);
          stock.classList.remove('is-low');
          if (!v.available) stock.textContent = '';
          else if (q !== null && q !== undefined && q > 0 && q < th) { stock.textContent = stock.dataset.low.replace('[count]', q); stock.classList.add('is-low'); }
          else stock.textContent = stock.dataset.in || '';
        }
        const save = $('[data-save-badge]', r);
        const sale = $('[data-sale-badge]', r);
        const pct = v.compare_at_price > v.price ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
        if (save) { save.hidden = !pct; save.textContent = `Save ${pct}%`; }
        if (sale) { sale.hidden = !pct; sale.textContent = `-${pct}%`; }
        const sv = $('[data-sticky-variant]', r.closest('section') || document);
        if (sv) sv.textContent = (v.title && v.title !== 'Default Title' ? v.title + ' · ' : '') + fmt(v.price);
      };
      r.addEventListener('variant:change', (e) => render(e.detail));
      const json = $('[data-product-json]', r);
      const idInput = $('input[name="id"]', r);
      if (json && idInput) {
        const p = JSON.parse(json.textContent);
        const v = p.variants.find((x) => String(x.id) === idInput.value);
        v && render(v);
      }
    });
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky(root = document) {
    $$('[data-sticky-atc]', root).forEach((bar) => {
      const section = bar.closest('section');
      const mainBtn = $('[data-add-button]', section);
      if (!mainBtn || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        $('[data-sticky-add]', bar).tabIndex = show ? 0 : -1;
      });
      io.observe(mainBtn);
      $('[data-sticky-add]', bar).addEventListener('click', () => {
        if (mainBtn.disabled) { mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        mainBtn.click();
      });
    });
  }

  /* ---------- Gift card recipient ---------- */
  document.addEventListener('change', (e) => {
    const t = e.target.closest('[data-recipient-toggle]');
    if (!t) return;
    const box = t.closest('[data-gift-recipient]');
    const fields = $('[data-recipient-fields]', box); if (fields) fields.hidden = !t.checked;
    $$('[data-recipient-field], [data-recipient-offset]', box).forEach((f) => { f.disabled = !t.checked; });
    const off = $('[data-recipient-offset]', box);
    if (off) off.value = new Date().getTimezoneOffset().toString();
    const email = $('input[type="email"]', box);
    if (email) email.required = t.checked;
  });

  /* ---------- Size chart units ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-units]');
    if (!b) return;
    const chart = b.closest('[data-size-chart]');
    const cm = b.dataset.units === 'cm';
    $$('[data-units]', chart).forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    $$('td[data-in]', chart).forEach((td) => {
      const raw = td.dataset.in;
      td.textContent = cm ? raw.replace(/\d+(\.\d+)?/g, (n) => String(Math.round(parseFloat(n) * 2.54))) : raw;
    });
  });

  /* ---------- Copy link ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-copy-link]');
    if (!b) return;
    navigator.clipboard && navigator.clipboard.writeText(b.dataset.copyLink).then(() => B.toast('Link copied!'));
  });

  /* ---------- Complete the look ---------- */
  async function initCtl(root = document) {
    for (const el of $$('[data-ctl-url]', root)) {
      try {
        const html = await (await fetch(el.dataset.ctlUrl)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = $('[data-ctl]', doc);
        if (fresh && $('.ctl', fresh)) { el.innerHTML = fresh.innerHTML; el.removeAttribute('data-ctl-url'); }
        else if (!window.Shopify || !window.Shopify.designMode) el.hidden = true;
      } catch (e) { el.hidden = true; }
    }
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ctl-add]');
    if (!btn) return;
    const sec = btn.closest('[data-ctl]');
    const items = $$('[data-ctl-variant]:checked', sec).map((i) => ({ id: Number(i.dataset.ctlVariant), quantity: 1 }));
    if (!items.length) { B.toast('Tick the pieces you want, or choose sizes first'); return; }
    B.addToCart(items, btn);
  });

  /* ==========================================================
     Collection filters (Section Rendering, no page reload)
     ========================================================== */
  function initFilters(root = document) {
    $$('[data-facets]', root).forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const sectionId = wrap.dataset.facets;
      const forms = () => $$('form[data-facet-form]', document);
      let timer;
      const go = (url, push = true) => {
        const target = new URL(url, window.location.origin);
        target.searchParams.set('section_id', sectionId);
        document.body.classList.add('is-filtering');
        fetch(target).then((r) => r.text()).then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-facet-results]', '[data-facet-sidebar]', '[data-facet-active]', '[data-facet-drawer]', '[data-facet-count]', '[data-search-tabs]'].forEach((sel) => {
            const fresh = $$(sel, doc), cur = $$(sel);
            cur.forEach((c, i) => { const f = fresh[i] || fresh[0]; if (f) c.innerHTML = f.innerHTML; });
          });
          target.searchParams.delete('section_id');
          if (push) history.pushState({}, '', target.pathname + target.search);
          B.refresh($('[data-facet-results]'));
          initPaging();
          document.body.classList.remove('is-filtering');
        }).catch(() => { window.location.href = url; });
      };
      const fromForm = (form) => {
        const fd = new FormData(form);
        const params = new URLSearchParams();
        for (const [k, v] of fd.entries()) if (v !== '') params.append(k, v);
        const sort = $('[data-sort]');
        if (sort && !params.has('sort_by')) params.set('sort_by', sort.value);
        return `${window.location.pathname}?${params.toString()}`;
      };
      document.addEventListener('change', (e) => {
        const form = e.target.closest('form[data-facet-form]');
        if (form) { clearTimeout(timer); timer = setTimeout(() => go(fromForm(form)), e.target.type === 'number' ? 600 : 50); }
        if (e.target.matches('[data-sort]')) {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', e.target.value);
          url.searchParams.delete('page');
          go(url.toString());
        }
      });
      document.addEventListener('submit', (e) => {
        const form = e.target.closest('form[data-facet-form]');
        if (form) { e.preventDefault(); go(fromForm(form)); }
      });
      document.addEventListener('click', (e) => {
        const a = e.target.closest('a[data-facet-link]');
        if (a) { e.preventDefault(); go(a.href); }
      });
      window.addEventListener('popstate', () => go(window.location.href, false));
    });
  }

  /* ---------- Grid column switcher ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-grid-cols]');
    if (!b) return;
    const grid = $('[data-facet-results] .grid');
    if (!grid) return;
    const v = b.dataset.gridCols;
    grid.classList.toggle('grid--editorial', v === 'editorial');
    if (v !== 'editorial') grid.style.setProperty('--cols', v);
    $$('[data-grid-cols]').forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    try { localStorage.setItem('bloomie:cols', v); } catch (err) {}
  });
  function restoreCols() {
    let v; try { v = localStorage.getItem('bloomie:cols'); } catch (e) {}
    if (!v) return;
    const b = $(`[data-grid-cols="${v}"]`);
    b && b.click();
  }

  /* ---------- Infinite scroll / load more ---------- */
  function initPaging() {
    const wrap = $('[data-paging]');
    if (!wrap) return;
    const mode = wrap.dataset.paging;
    const btn = $('[data-load-more]', wrap);
    if (!btn) return;
    const load = async () => {
      if (btn.dataset.loading) return;
      btn.dataset.loading = '1';
      btn.textContent = 'Loading…';
      const html = await (await fetch(btn.dataset.loadMore)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = $('[data-facet-results] .grid');
      const freshGrid = $('[data-facet-results] .grid', doc);
      if (grid && freshGrid) {
        Array.from(freshGrid.children).forEach((c) => grid.appendChild(c));
        B.refresh(grid);
      }
      const freshPaging = $('[data-paging]', doc);
      wrap.innerHTML = freshPaging ? freshPaging.innerHTML : '';
      initPaging();
    };
    btn.addEventListener('click', load);
    if (mode === 'infinite' && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(btn);
    }
  }

  /* ---------- Card video preview ---------- */
  document.addEventListener('mouseover', (e) => {
    const card = e.target.closest('.card');
    if (!card) return;
    const v = $('video[data-card-video]', card);
    if (v && v.paused) v.play().catch(() => {});
  });
  document.addEventListener('mouseout', (e) => {
    const card = e.target.closest('.card');
    if (!card || card.contains(e.relatedTarget)) return;
    const v = $('video[data-card-video]', card);
    if (v) { v.pause(); v.currentTime = 0; }
  });

  /* ==========================================================
     Cart page
     ========================================================== */
  function initCartPage() {
    const page = $('[data-cart-page]');
    if (!page) return;
    if (B.refreshCartRecs) B.refreshCartRecs();
    const change = async (key, qty) => {
      page.classList.add('is-loading');
      await fetch(`${B.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
      window.location.reload();
    };
    $$('[data-line-qty]', page).forEach((w) => {
      const input = $('input', w);
      $('[data-qty-minus]', w).addEventListener('click', () => change(w.dataset.lineQty, Math.max(0, Number(input.value) - 1)));
      $('[data-qty-plus]', w).addEventListener('click', () => change(w.dataset.lineQty, Number(input.value) + 1));
      input.addEventListener('change', () => change(w.dataset.lineQty, Math.max(0, Number(input.value))));
    });
    $$('[data-line-remove]', page).forEach((b) => b.addEventListener('click', () => change(b.dataset.lineRemove, 0)));
    const wrap = $('[data-page-gift-wrap]', page);
    wrap && wrap.addEventListener('change', async () => {
      page.classList.add('is-loading');
      if (wrap.checked) await fetch(`${B.routes.cartAdd}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(wrap.dataset.variant), quantity: 1 }] }) });
      else await fetch(`${B.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: wrap.dataset.lineKey, quantity: 0 }) });
      window.location.reload();
    });
    let t;
    const note = $('[data-page-gift-message]', page);
    note && note.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(() => fetch(`${B.routes.cartUpdate}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Gift message': note.value } }) }), 500);
    });
    const df = $('[data-page-discount]', page);
    const checkout = $('[data-page-checkout]', page);
    const apply = (code) => { if (checkout) checkout.href = code ? `/checkout?discount=${encodeURIComponent(code)}` : '/checkout'; };
    if (df) {
      const input = $('input', df);
      const saved = sessionStorage.getItem('bloomie:discount');
      if (saved) { input.value = saved; apply(saved); }
      df.addEventListener('submit', (e) => {
        e.preventDefault();
        const code = input.value.trim();
        sessionStorage.setItem('bloomie:discount', code);
        apply(code);
        const msg = $('[data-page-discount-msg]', page);
        if (msg) msg.textContent = code ? `Code “${code}” will be applied at checkout.` : '';
      });
    }
  }

  function init(root = document) {
    initGallery(root);
    initStock(root);
    initSticky(root);
    initCtl(root);
    initFilters(root);
  }
  document.addEventListener('DOMContentLoaded', () => {
    init();
    initPaging();
    restoreCols();
    initCartPage();
  });
  document.addEventListener('shopify:section:load', (e) => { init(e.target); initPaging(); });
})();
